import { render, staticRenderFns } from "./AvailableSoon.vue?vue&type=template&id=16e0c3a4&scoped=true"
import script from "./AvailableSoon.vue?vue&type=script&lang=js"
export * from "./AvailableSoon.vue?vue&type=script&lang=js"
import style0 from "./AvailableSoon.vue?vue&type=style&index=0&id=16e0c3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0c3a4",
  null
  
)

export default component.exports